export function subscriptions(state = { error: false, loading: false, data: [] }, action) {
  switch (action.type) {
    case "GET_SUBSCRIPTION_SUCCESS":
      return action;
    default:
      return state;
  }
}
